import { makeStyles } from "@material-ui/styles"

const styles = makeStyles(theme => ({
  root: {},
  accordionDetails: {
    maxHeight: 600,
    overflow: "auto"
  },
  accordionSummary: {
    minHeight: "unset",
    "&.MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "unset",
      borderBottom: "1px solid rgba(112, 112, 112, .15)"
    },
    "& > .MuiAccordionSummary-content.Mui-expanded": {
      margin: theme.spacing(1.5, 0)
    }
  },
  selectAllButton: {
    color: theme.palette.primary.main + "!important"
  },
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.primary.main + "0D"
    }
  },
  usersSelected: {
    opacity: 0.4,
    marginLeft: theme.spacing(0.5)
  },
  checkbox: {
    width: 20,
    height: 20,
    color: theme.palette.primary.main + "!important"
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationText/CommunicationTextAccordion/UserAccordion/styles.js